const { REACT_APP_VERSION } = process.env;

window.LFApp = {
  improveDeveloperExperience: process.env.REACT_APP_IMPROVE_DEVELOPER_EXPERIENCE === 'true' && process.env.NODE_ENV === 'development',
  version: REACT_APP_VERSION,
  env: process.env.NODE_ENV,
  unityDebug: false,
  unity: {
    actionsDebuggingEnabled: true,
  }
}

